/* SANDS collection V2 — rails, Women/Men switch, model filter, description toggle */
(function () {
  if (window.__sc2Init) return;
  window.__sc2Init = true;

  /* Description: clamp to 3 lines, "Read more" only when it is actually cut */
  function initDesc(root) {
    root.querySelectorAll('[data-sc2-desc]').forEach(function (box) {
      if (box.__sc2) return;
      box.__sc2 = true;
      var text = box.querySelector('[data-sc2-desc-text]');
      var btn = box.querySelector('[data-sc2-desc-more]');
      if (!text || !btn) return;
      function check() {
        if (box.classList.contains('is-open')) return;
        btn.hidden = text.scrollHeight <= text.clientHeight + 2;
      }
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        btn.textContent = open ? 'Read less' : 'Read more';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      check();
      window.addEventListener('resize', check);
    });
  }

  /* Rails: arrows only when the rail overflows */
  function initRail(sec) {
    var rail = sec.querySelector('[data-sc2-rail]');
    var nav = sec.querySelector('[data-sc2-rail-nav]');
    if (!rail || !nav || rail.classList.contains('sc2-rail--grid')) return;
    var prev = nav.querySelector('[data-sc2-prev]');
    var next = nav.querySelector('[data-sc2-next]');
    function update() {
      var over = rail.scrollWidth > rail.clientWidth + 4;
      nav.hidden = !over;
      if (!over) return;
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    }
    function step(dir) {
      rail.scrollBy({ left: dir * Math.max(rail.clientWidth * 0.8, 200), behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    sec.__sc2Update = update;
  }

  /* Women / Men switch: same data attributes as the original brand carousel */
  function initGender(sec) {
    var buttons = sec.querySelectorAll('.sc2-seg__btn[data-gender]');
    if (!buttons.length) return;
    var tiles = sec.querySelectorAll('.sc2-tile');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var g = button.dataset.gender;
        buttons.forEach(function (b) {
          var on = b === button;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        tiles.forEach(function (tile) {
          var href = g === 'men' ? tile.dataset.menUrl : tile.dataset.womenUrl;
          var src = g === 'men' ? tile.dataset.menImage : tile.dataset.womenImage;
          var li = tile.closest('li');
          if (li) li.hidden = !href;
          if (href) tile.href = href;
          var img = tile.querySelector('img');
          if (img && src && img.getAttribute('src') !== src) {
            img.classList.add('is-swapping');
            var pre = new Image();
            pre.onload = pre.onerror = function () {
              img.src = src;
              img.classList.remove('is-swapping');
            };
            pre.src = src;
          }
        });
        var rail = sec.querySelector('[data-sc2-rail]');
        if (rail) rail.scrollTo({ left: 0 });
        if (sec.__sc2Update) sec.__sc2Update();
      });
    });
  }

  /* Model rail: filter the grid in place, like the original collection carousel */
  function markActive(sec) {
    var param = sec.dataset.param;
    var current = new URLSearchParams(location.search).getAll(param);
    sec.querySelectorAll('.sc2-tile--model').forEach(function (tile) {
      var on = current.indexOf(tile.dataset.value) !== -1;
      tile.classList.toggle('is-active', on);
      if (on) tile.setAttribute('aria-current', 'true'); else tile.removeAttribute('aria-current');
    });
  }
  function swapGrid(url) { return sc2Go(url, { push: false }); }
  function initModels(sec) {
    markActive(sec);
    sec.querySelectorAll('.sc2-tile--model').forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        var target = new URL(tile.href, location.origin);
        if (target.pathname !== location.pathname) return; // another collection: normal navigation
        e.preventDefault();
        var param = sec.dataset.param;
        var on = tile.classList.contains('is-active');
        var url = new URL(location.href);
        url.searchParams.delete(param);
        url.searchParams.delete('page');
        if (!on) url.searchParams.set(param, tile.dataset.value);
        history.pushState({ sc2: true }, '', url.toString());
        markActive(sec);
        swapGrid(url.toString());
      });
    });
    window.addEventListener('popstate', function () { markActive(sec); });
  }

  /* Editorial hero (Custom Liquid): on phones the story is cut after 5 lines */
  function initHero(root) {
    root.querySelectorAll('.sands-editorial-hero').forEach(function (hero) {
      if (hero.__sc2) return;
      hero.__sc2 = true;
      var texts = hero.querySelectorAll('.sands-editorial-hero__text');
      if (!texts.length) return;
      var last = texts[texts.length - 1];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sc2-link sc2-hero-more';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      btn.hidden = true;
      last.insertAdjacentElement('afterend', btn);
      function check() {
        if (hero.classList.contains('is-open')) return;
        var t = texts[0];
        btn.hidden = !(t.scrollHeight > t.clientHeight + 2 || texts.length > 1 && getComputedStyle(texts[1]).display === 'none');
      }
      btn.addEventListener('click', function () {
        var open = hero.classList.toggle('is-open');
        btn.textContent = open ? 'Read less' : 'Read more';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      check();
      window.addEventListener('resize', check);
    });
  }


  /* ---------- Collection grid: filter bar, drawer, sort, pagination ---------- */
  var loading = false;
  function results() { return document.querySelector('[data-sc2-results]'); }
  function sectionId() { var g = document.querySelector('[data-sc2-section]'); return g ? g.getAttribute('data-sc2-section') : null; }
  function withSection(url) {
    var id = sectionId();
    if (!id) return url;
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', id);
    return u.toString();
  }
  function cleanUrl(url) {
    var u = new URL(url, location.origin);
    u.searchParams.delete('section_id');
    return u.pathname + (u.search ? u.search : '');
  }
  var pending = null;
  function drawerState() {
    var d = document.querySelector('[data-sc2-drawer]');
    if (!d || d.hidden) return null;
    var body = d.querySelector('.sc2-drawer__body');
    var open = [];
    d.querySelectorAll('details[data-key]').forEach(function (x) { if (x.open) open.push(x.getAttribute('data-key')); });
    var a = document.activeElement;
    return { scroll: body ? body.scrollTop : 0, open: open, focus: a && a.name ? { name: a.name, value: a.value } : null };
  }
  function restoreDrawer(st) {
    var d = document.querySelector('[data-sc2-drawer]');
    if (!d || !st) return;
    d.classList.add('no-anim');
    d.hidden = false;
    d.classList.add('is-open');
    document.documentElement.classList.add('sc2-lock');
    d.querySelectorAll('details[data-key]').forEach(function (x) { x.open = st.open.indexOf(x.getAttribute('data-key')) !== -1; });
    var body = d.querySelector('.sc2-drawer__body');
    if (body) body.scrollTop = st.scroll;
    if (st.focus) {
      var el = Array.prototype.find.call(d.querySelectorAll('input'), function (i) { return i.name === st.focus.name && i.value === st.focus.value; });
      if (el) el.focus({ preventScroll: true });
    }
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.remove('no-anim'); }); });
  }
  /* Colour-variant app (Sezerium) on this collection: it only re-renders its cards correctly on a full
     page load, so filters / sort reload the page there. The drawer still updates its counts live. */
  var sezPending = null;
  function sezActive() { return !!(document.querySelector('#product-grid.sezerium-collection') || document.querySelector('script[src*="sezerium-variant"]')); }
  function sc2Go(url, opts) {
    opts = opts || {};
    var box = results();
    if (!box) { location.href = url; return Promise.resolve(); }
    var sez = sezActive();
    if (sez && !opts.keepDrawer) {
      sezPending = null;
      box.classList.add('sc2-loading');
      location.href = cleanUrl(url);
      return Promise.resolve();
    }
    if (loading) { pending = { url: url, opts: opts }; return Promise.resolve(); }
    loading = true;
    var keep = opts.keepDrawer ? drawerState() : null;
    if (!keep) closeDrawer();
    closePops();
    box.classList.add('sc2-loading');
    return fetch(withSection(url), { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sc2-results]');
        if (!fresh) throw new Error('no results');
        if (sez) {
          var dNew = fresh.querySelector('[data-sc2-drawer]');
          var dOld = box.querySelector('[data-sc2-drawer]');
          if (dNew && dOld) dOld.parentNode.replaceChild(document.importNode(dNew, true), dOld);
          if (keep) restoreDrawer(keep);
          sezPending = cleanUrl(url);
          return;
        }
        box.innerHTML = fresh.innerHTML;
        if (keep) restoreDrawer(keep);
        if (opts.push !== false) history.pushState({ sc2: true }, '', cleanUrl(url));
        updateHeaderCount(doc);
        fitQuick();
        document.querySelectorAll('[data-sc2-model-rail]').forEach(markActive);
        if (typeof window.initProductGrid === 'function') { try { window.initProductGrid(); } catch (e) {} }
        document.dispatchEvent(new CustomEvent('collection:update', { detail: { url: url } }));
        var bar = document.querySelector('[data-sc2-bar]');
        var anchor = bar || box;
        var top = anchor.getBoundingClientRect().top;
        if (!keep && (opts.toTop || top < 0 || top > window.innerHeight * 0.6)) {
          window.scrollTo({ top: window.scrollY + box.getBoundingClientRect().top - stickyTop() - 8, behavior: 'smooth' });
        }
      })
      .catch(function () { location.href = cleanUrl(url); })
      .finally(function () {
        loading = false;
        box.classList.remove('sc2-loading');
        if (pending) { var p = pending; pending = null; sc2Go(p.url, p.opts); }
      });
  }
  window.__sc2Go = sc2Go;

  /* Quick brand chips: show as many as fit on one line */
  function fitQuick() {
    document.querySelectorAll('.sc2-bar__left').forEach(function (left) {
      var chips = left.querySelectorAll('.sc2-quick > .sc2-pill');
      if (!chips.length) return;
      chips.forEach(function (c) { c.hidden = false; });
      var sep = left.querySelector('.sc2-sep--quick');
      if (sep) sep.hidden = false;
      if (getComputedStyle(left).display === 'contents') return;
      var first = left.firstElementChild;
      var limit = (first ? first.offsetHeight : 42) + 6;
      for (var i = chips.length - 1; i >= 0 && left.offsetHeight > limit; i--) chips[i].hidden = true;
      var any = Array.prototype.some.call(chips, function (c) { return !c.hidden; });
      if (sep) sep.hidden = !any;
    });
  }
  function updateHeaderCount(doc) {
    var a = document.querySelector('.sc2-count');
    var b = doc.querySelector('.sc2-count');
    if (a && b) a.textContent = b.textContent;
  }

  /* Height of the site header when it sticks, so the bar sits right under it */
  function stickyTop() {
    var h = 0;
    var cands = document.querySelectorAll('sticky-header, .shopify-section-header-sticky, #shopify-section-headerV2, .shopify-section-group-header-group');
    cands.forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        var r = el.getBoundingClientRect();
        if (r.bottom > h && r.top <= 1) h = r.bottom;
      }
    });
    return Math.max(0, Math.round(h));
  }
  function setStickyTop() {
    var t = stickyTop();
    document.documentElement.style.setProperty('--sc2-sticky-top', t + 'px');
  }

  /* Popovers (price, colour) */
  function closePops(except) {
    document.querySelectorAll('[data-sc2-pop].is-open').forEach(function (p) {
      if (p === except) return;
      p.classList.remove('is-open');
      var b = p.querySelector('[data-sc2-pop-btn]'); if (b) b.setAttribute('aria-expanded', 'false');
      var panel = p.querySelector('[data-sc2-pop-panel]'); if (panel) panel.hidden = true;
    });
  }
  function togglePop(pop) {
    var open = !pop.classList.contains('is-open');
    closePops(pop);
    pop.classList.toggle('is-open', open);
    var b = pop.querySelector('[data-sc2-pop-btn]'); if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    var panel = pop.querySelector('[data-sc2-pop-panel]');
    if (panel) {
      panel.hidden = !open;
      if (open) {
        panel.style.left = ''; panel.style.right = '';
        var r = panel.getBoundingClientRect();
        if (r.right > window.innerWidth - 12) { panel.style.left = 'auto'; panel.style.right = '0'; }
        var f = panel.querySelector('input, a'); if (f) f.focus({ preventScroll: true });
      }
    }
  }

  /* Drawer */
  var lastFocus = null;
  function openDrawer() {
    var d = document.querySelector('[data-sc2-drawer]');
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    document.documentElement.classList.add('sc2-lock');
    var panel = d.querySelector('.sc2-drawer__panel'); if (panel) panel.focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (sezPending) {
      var u = sezPending;
      sezPending = null;
      if (cleanUrl(u) !== cleanUrl(location.pathname + location.search)) {
        var rb = results(); if (rb) rb.classList.add('sc2-loading');
        location.href = u;
      }
    }
    var d = document.querySelector('[data-sc2-drawer]');
    document.documentElement.classList.remove('sc2-lock');
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    setTimeout(function () { d.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function formUrl(form) {
    var fd = new FormData(form);
    var params = new URLSearchParams();
    var sort = null;
    fd.forEach(function (v, k) {
      if (v === '' || v == null) return;
      if (k === 'sort_by') { sort = v; return; }
      params.append(k, v);
    });
    if (sort) params.set('sort_by', sort);
    var base = form.getAttribute('action') || location.pathname;
    var q = params.toString();
    return base + (q ? '?' + q : '');
  }

  function sezGridEl() { return document.querySelector('#product-grid.sezerium-collection'); }

  /* Colour-variant app (Sezerium): it shows each colour as its own card and counts the cards
     (e.g. 3,184 instead of 1,600 products). Mirror its total in our counters, like the live theme does. */
  var sezTotal = 0;
  function fmtNum(n) { return Number(n).toLocaleString('en-US'); }
  function readSezSpan() {
    var sp = document.querySelector('.sc2-sez-count');
    if (!sp) return;
    var n = parseInt((sp.textContent || '').replace(/[^0-9]/g, ''), 10);
    var liquid = parseInt(sp.getAttribute('data-liquid') || '', 10);
    if (n && n !== liquid) sezTotal = n;
  }
  /* Only touch the DOM when the value changes: other scripts (currency / market apps) observe
     these counters, and rewriting the same text kept them and our observer in an endless loop */
  function setText(el, v) { if (el && el.textContent !== v) el.textContent = v; }
  function sezSync() {
    var grid = sezGridEl();
    if (!grid || !sezTotal) return;
    var label = fmtNum(sezTotal) + ' pieces';
    setText(document.querySelector('.sc2-count'), label);
    if (!grid.hasAttribute('data-sc2-unfiltered')) return;
    document.querySelectorAll('.sc2-shown').forEach(function (el) { setText(el, label); });
    setText(document.querySelector('[data-sc2-show]'), 'Show ' + label);
  }
  function initSez() {
    readSezSpan();
    document.addEventListener('sezerium:set:productCount', function (e) {
      var d = e.detail || {};
      if (d.productCount > 0) { sezTotal = d.productCount; sezSync(); }
    });
    var box = results();
    if (!box || !window.MutationObserver) return;
    var t = null;
    /* React only to the app's cards and its hidden count, never to our own counters or the filter bar */
    new MutationObserver(function (records) {
      var relevant = records.some(function (r) {
        var el = r.target.nodeType === 1 ? r.target : r.target.parentElement;
        return el && el.closest('#product-grid, .sc2-sez-count');
      });
      if (!relevant) return;
      clearTimeout(t);
      t = setTimeout(function () { readSezSpan(); sezSync(); }, 250);
    }).observe(box, { childList: true, subtree: true });
    sezSync();
  }

  /* One set of delegated listeners for everything inside the results */
  function initGrid() {
    if (!document.querySelector('[data-sc2-results]') || window.__sc2Grid) return;
    window.__sc2Grid = true;
    initSez();
    setStickyTop();
    fitQuick();
    window.addEventListener('resize', function () { setStickyTop(); fitQuick(); });
    window.addEventListener('scroll', function () { if (window.scrollY < 400) setStickyTop(); }, { passive: true });

    document.addEventListener('click', function (e) {
      var t = e.target;
      var popBtn = t.closest('[data-sc2-pop-btn]');
      if (popBtn) { e.preventDefault(); togglePop(popBtn.closest('[data-sc2-pop]')); return; }
      if (!t.closest('[data-sc2-pop]')) closePops();
      if (t.closest('[data-sc2-open-drawer]')) { e.preventDefault(); openDrawer(); return; }
      if (t.closest('[data-sc2-close-drawer]')) { e.preventDefault(); closeDrawer(); return; }
      var page = t.closest('[data-sc2-results] .pagination a[href]');
      if (page && !e.metaKey && !e.ctrlKey && !e.shiftKey) { e.preventDefault(); sc2Go(page.getAttribute('href'), { toTop: true }); return; }
      var nav = t.closest('a[data-sc2-nav]');
      if (nav && !e.metaKey && !e.ctrlKey && !e.shiftKey) { e.preventDefault(); sc2Go(nav.getAttribute('href')); }
    });
    var liveT = null;
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-sc2-filter-form]');
      if (!form) return;
      e.preventDefault();
      clearTimeout(liveT);
      var inDrawer = !!form.closest('[data-sc2-drawer]');
      var url = formUrl(form);
      if (inDrawer && cleanUrl(url) === cleanUrl(location.pathname + location.search)) { closeDrawer(); return; }
      sc2Go(url);
    });
    /* Filters in the drawer apply as soon as they are ticked; "Show N pieces" just closes it */
    document.addEventListener('change', function (e) {
      var form = e.target.closest('[data-sc2-drawer] [data-sc2-filter-form]');
      if (!form) return;
      clearTimeout(liveT);
      liveT = setTimeout(function () { sc2Go(formUrl(form), { keepDrawer: true }); }, e.target.type === 'number' ? 600 : 250);
    });
    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-sc2-sort]');
      if (!sel) return;
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      sc2Go(u.pathname + u.search);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closePops(); closeDrawer(); }
    });
    window.addEventListener('popstate', function () {
      if (document.querySelector('[data-sc2-results]')) sc2Go(location.pathname + location.search, { push: false });
    });
  }

  function init(root) {
    root = root || document;
    initDesc(root);
    initHero(root);
    initGrid();
    root.querySelectorAll('[data-sc2-brand-rail], [data-sc2-model-rail]').forEach(function (sec) {
      if (sec.__sc2) return;
      sec.__sc2 = true;
      initRail(sec);
      initGender(sec);
      if (sec.dataset.defaultGender === 'men') {
        var m = sec.querySelector('.sc2-seg__btn[data-gender="men"]');
        if (m) m.click();
      }
      if (sec.hasAttribute('data-sc2-model-rail')) initModels(sec);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
